import axios from "axios";
import consts from "@/const/const";

const repository = axios.create({
  baseURL: consts.apiyumenaviinfo,
  // headers: {
  //   'X-Requested-With': 'XMLHttpRequest',
  //   'Content-Type': 'application/json; charset=utf-8',
  //   'Access-Control-Allow-Origin': '*',
  // },
});

export default (resource: string) => {
  return {
    get() {
      return repository.get(`${resource}`);
    },
    getQuery(getQuery: string) {
      return repository.get(`${resource}${getQuery}`);
    },
    post(payload: string) {
      return repository.post(`${resource}`, payload);
    },
  };
};
